"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  id: 1,
  name: "American Kennel Club",
  src: "https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/ackcsclogo.png?v=jdygqfuzaoh"
}, {
  id: 2,
  name: "CKCSC USA",
  src: "https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/ckcsc-full-elongated-logo.png?v=ba0we4bcxri"
}, {
  id: 3,
  name: "Orthopedic Foundation for Animals",
  src: "https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/OFA-logo.png?v=mr8c0xihnt"
}, {
  id: 4,
  name: "Canine Health Information Center",
  src: "https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/AKC_BOM_logo-2.avif?v=kgzqs3nrsjq"
}, {
  id: 5,
  name: "AKC Reunite",
  src: "https://milehighcavaliers.10web.cloud/wp-content/uploads/2026/03/cavalier-rescue-trust.jpg?v=2qj2ilxjy4m"
}];
export default function PartnerNetwork() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="143807" id="our-credentials" className="bg-background text-foreground py-16 md:py-24 border-t border-secondary/20">
      <div ref={ref} className={`container mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-center font-sans uppercase tracking-widest text-primary mb-10 !text-3xl md:mb-16">RECOGNIZED FOR EXCELLENCE</h2>
        
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 !h-[300px] md:gap-x-16 lg:gap-x-24">
          {partners.map((partner, i) => <div key={partner.id} data-index={i} className="flex items-center justify-center group">
              <img src={partner.src} alt={`${partner.name} logo`} className="object-contain grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-700 ease-in-out !h-[100px] !w-[200px]" />
            </div>)}
        </div>
      </div>
    </section>;
}